import ApiService from "@/core/services/api.service";

const actions = {
  /**
   *
   * @param context
   * @param payload
   * @returns {*}
   */
  transferStaffSuperAdminRole(context, payload) {
    ApiService.setHeader();
    return ApiService.post(
      "school/employee/staff/privilege/transfer",
      payload
    ).then((response) => response);
  },
};

export default {
  actions,
};
